import I18n from 'I18n';

// @ts-expect-error dependency missing types
import HUBSPOT_CREDITS_HERO from 'bender-url!pricing-pages-lib/images/hubspot-credits/hero.png';
// @ts-expect-error dependency missing types
import BREEZE_ACTIONS_WORKFLOWS from 'bender-url!pricing-pages-lib/images/keyFeatures/breeze_actions_workflows.png';
// @ts-expect-error dependency missing types
import BUYER_INTENT_INBOUND from 'bender-url!pricing-pages-lib/images/keyFeatures/buyer_intent_inbound.png';
// @ts-expect-error dependency missing types
import CUSTOMER_AGENT_SERVICE_COMMERCE from 'bender-url!pricing-pages-lib/images/keyFeatures/customer_agent_service_commerce.png';
// @ts-expect-error dependency missing types
import CUSTOMER_AGENT_SALES from 'bender-url!pricing-pages-lib/images/keyFeatures/customer_agent_sales.png';
// @ts-expect-error dependency missing types
import CUSTOMER_AGENT_MARKETING_CONTENT from 'bender-url!pricing-pages-lib/images/keyFeatures/customer_agent_marketing_content.png';
// @ts-expect-error dependency missing types
import CUSTOMER_AGENT_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/customerAgent_callout.png';
// @ts-expect-error dependency missing types
import DATA_AGENT from 'bender-url!pricing-pages-lib/images/keyFeatures/data_agent.png';
// @ts-expect-error dependency missing types
import DATA_AGENT_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/dataAgent_callout.png';
// @ts-expect-error dependency missing types
import DATA_STUDIO from 'bender-url!pricing-pages-lib/images/keyFeatures/data_studio.png';
// @ts-expect-error dependency missing types
import DATA_STUDIO_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/dataStudio_callout.png';
// @ts-expect-error dependency missing types
import PROSPECTING_AGENT from 'bender-url!pricing-pages-lib/images/keyFeatures/prospecting_agent.png';
// @ts-expect-error dependency missing types
import PROSPECTING_AGENT_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/prospectingAgent_callout.png';
import { DE, ES, FR, JA, PT } from 'self-service-api/constants/Languages';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { CREDITS_RELATED_FEATURES } from '../../utils/getHubSpotCreditsKeyFeatures';
const SUPPORTED_LANGS = ['en', 'es', 'fr', 'de', 'pt', 'ja', 'nl'];
const CMS_BASE_URL = 'https://f.hubspotusercontent00.net/hubfs/53';
const getImageUrl = extension => CMS_BASE_URL + extension;
export const getHubSpotCreditsHeroImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20page%20-%20Credits%20hero/credits_hero_${langToUse.toUpperCase()}.png`);
    default:
      return HUBSPOT_CREDITS_HERO;
  }
};
const getDataAgentFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Key%20Features/data_agent_${langToUse.toUpperCase()}.png`);
    default:
      return DATA_AGENT;
  }
};
export const getDataAgentCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Callout/dataAgent_callout_${langToUse.toUpperCase()}.png`);
    default:
      return DATA_AGENT_CALLOUT;
  }
};
const _getCustomerAgentServiceCommerceImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/pricing-uis/Service%20and%20Commerce%20Hub%20Customer%20agent_${langToUse.toUpperCase()}.png`);
    default:
      return CUSTOMER_AGENT_SERVICE_COMMERCE;
  }
};
const _getCustomerAgentSalesImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/pricing-uis/Sales%20Hub%20Customer%20agent_${langToUse.toUpperCase()}.png`);
    default:
      return CUSTOMER_AGENT_SALES;
  }
};
const _getCustomerAgentMarketingContentImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/pricing-uis/Marketing%20and%20Content%20Hub%20Customer%20agent_${langToUse.toUpperCase()}.png`);
    default:
      return CUSTOMER_AGENT_MARKETING_CONTENT;
  }
};
const getCustomerAgentFeatureImage = variant => {
  switch (variant) {
    case NavItemEnum.SERVICE:
    case NavItemEnum.COMMERCE:
      return _getCustomerAgentServiceCommerceImage();
    case NavItemEnum.SALES:
      return _getCustomerAgentSalesImage();
    case NavItemEnum.MARKETING:
    case NavItemEnum.CONTENT:
    case NavItemEnum.MARKETING_PLUS:
    default:
      return _getCustomerAgentMarketingContentImage();
  }
};
export const getCustomerAgentCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Callout/customerAgent_callout_${langToUse.toUpperCase()}.png`);
    default:
      return CUSTOMER_AGENT_CALLOUT;
  }
};
const getBreezeActionsWorkflowsFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/pricing-uis/Breeze%20actions%20in%20workflows%20Final_${langToUse.toUpperCase()}.png`);
    default:
      return BREEZE_ACTIONS_WORKFLOWS;
  }
};
const getProspectingAgentFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Key%20Features/prospecting_agent_${langToUse.toUpperCase()}.png`);
    default:
      return PROSPECTING_AGENT;
  }
};
export const getProspectingAgentCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Callout/prospectingAgent_callout_${langToUse.toUpperCase()}.png`);
    default:
      return PROSPECTING_AGENT_CALLOUT;
  }
};
const getBuyerIntentInboundFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Key%20Features/buyer_intent_${langToUse.toUpperCase()}.png`);
    default:
      return BUYER_INTENT_INBOUND;
  }
};
const getDataStudioFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Key%20Features/data_studio_${langToUse.toUpperCase()}.png`);
    default:
      return DATA_STUDIO;
  }
};
export const getDataStudioCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/Pricing%20Pages%20-%20Credits%20Callout/dataStudio_callout_${langToUse.toUpperCase()}.png`);
    default:
      return DATA_STUDIO_CALLOUT;
  }
};
export const getLocalizedImages = (name, variant) => {
  switch (name) {
    case CREDITS_RELATED_FEATURES.breezeActionsWorkflows:
      return getBreezeActionsWorkflowsFeatureImage();
    case CREDITS_RELATED_FEATURES.buyerIntent:
      return getBuyerIntentInboundFeatureImage();
    case CREDITS_RELATED_FEATURES.customerAgent:
      return getCustomerAgentFeatureImage(variant);
    case CREDITS_RELATED_FEATURES.dataAgent:
      return getDataAgentFeatureImage();
    case CREDITS_RELATED_FEATURES.dataStudio:
      return getDataStudioFeatureImage();
    case CREDITS_RELATED_FEATURES.prospectingAgent:
      return getProspectingAgentFeatureImage();
    default:
      return [];
  }
};